var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"navbar-burger",staticStyle:{"left":"0","position":"absolute"},attrs:{"role":"button","aria-label":"menu","aria-expanded":"false"},on:{"click":function($event){return _vm.openMenu()}}},[_c('span',{attrs:{"aria-hidden":"true"}}),_c('span',{attrs:{"aria-hidden":"true"}}),_c('span',{attrs:{"aria-hidden":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }